<div class="w-full">
  <div class="text-center mb-6 md:mb-8 flex flex-col gap-4 md:gap-6">
    @if (modalData?.isUpdate) {
      <h4 class="paragraph-large bold">{{ 'buildYourNetwork.referralInformation' | translate }}</h4>
    } @else {
      @if (!userType() || userType() === UserTypes.SD || userType() === UserTypes.MU) {
        <h4 class="paragraph-large bold">{{ 'dashboard.addNewReferral' | translate }}</h4>
        <p class="paragraph-medium light">{{ 'dashboard.inviteFriendsFromUS' | translate }}</p>
      }
      @if (userType() === UserTypes.PR) {
        <h4 class="paragraph-large bold">{{ 'dashboard.addNewGanasocio' | translate }}</h4>
        <p class="paragraph-medium light">{{ 'dashboard.bringPartnerOnBoard' | translate }}</p>
      }
      @if (userType() === UserTypes.CO) {
        <h4 class="paragraph-large bold">{{ 'dashboard.addNewGanagente' | translate }}</h4>
        <p class="paragraph-medium light">{{ 'dashboard.connectWithCoordinatorToExpand' | translate }}</p>
      }
      @if (userType() === UserTypes.RE) {
        <h4 class="paragraph-large bold">{{ 'dashboard.addNewGanaquipo' | translate }}</h4>
        <p class="paragraph-medium light">{{ 'dashboard.addRecruiterStrengthen' | translate }}</p>
      }
      @if (userType() === UserTypes.AY) {
        <h4 class="paragraph-large bold">{{ 'dashboard.addNewGanaliados' | translate }}</h4>
        <p class="paragraph-medium light">{{ 'dashboard.bringAnAssociate' | translate }}</p>
      }
    }
  </div>
  @if (
    userType() === UserTypes.PR ||
    userType() === UserTypes.AY ||
    userType() === UserTypes.CO ||
    userType() === UserTypes.RE
  ) {
    <app-ganasocio-user-form
      [prefillData]="modalData?.prefillData"
      (onAddReferral)="onFormSubmit($event)"
      #ganasocioUserForm
    />
  } @else {
    <app-default-users-form
      [prefillData]="modalData?.prefillData"
      [modalUserType]="userType()"
      (onAddReferral)="onFormSubmit($event)"
      #defaultUsersForm
    />
  }
  <div *nzModalFooter class="flex justify-end gap-4">
    <korviu-button type="button" color="ghost" (click)="onCancel()" class="w-full">
      {{ 'common.cancel' | translate }}
    </korviu-button>
    @if (modalData?.isUpdate) {
      <korviu-button type="button" [disabled]="!formIsValid" color="tertiary" (click)="onShareClick()" class="w-full">
        {{ 'common.update' | translate }}
      </korviu-button>
    } @else {
      <korviu-button type="button" [disabled]="!formIsValid" color="tertiary" (click)="onShareClick()" class="w-full">
        {{ isGanasocios ? ('common.submit' | translate) : ('common.send' | translate) }}
      </korviu-button>
    }
  </div>
</div>
